module.exports = __webpack_public_path__ + "static/media/import.78fe4470.svg";